<template>
  <view wx:if="{{banner}}" class="banner-container">
    <swiper
      class="swiper-container"
      indicator-dots="{{!onlyOne}}"
      indicator-active-color="#fff"
      indicator-color="rgba(255, 255, 255, 0.3)"
      scroll-options="{{swiperOption}}"
      circular
      autoplay="{{!onlyOne}}"
      interval="{{2000}}"
      bindchange="handleSwiperChange"
    >
      <swiper-item  wx:for="{{banner}}" wx:key="image">
        <image class="image" src="{{item.image}}" bindtap="click(item)" />
      </swiper-item>
    </swiper>
  </view>
</template>
<script>
import { createComponent } from '@mpxjs/core'
import { goTo, businessResourceLog, is } from '@didi/webx-js'
import api from '../../lib/service'
import { pageStyle } from '../../lib/store'

createComponent({
  properties: {
    template: String,
  },
  async attached() {
    if (!pageStyle[this.template].businessId) {
      return
    }
    const res = await api.getBanner({
      resource_names: 'didi_applets_union_banner',
      business_id: pageStyle[this.template].businessId,
    })
    this.banner = res?.data?.didi_applets_union_banner || null
    this.banner && businessResourceLog({
      activity: this.banner[0],
      trackType: 3,
    })
  },
  data() {
    return {
      swiperOption: {
        eventPassthrough: 'vertical',
      },
      banner: null,
    }
  },
  computed: {
    onlyOne() {
      return this.banner?.length === 1
    },
  },
  methods: {
    handleSwiperChange(e) {
      businessResourceLog({
        activity: this.banner[e.detail.current],
        trackType: 3,
      })
    },
    click(item) {
      businessResourceLog({
        activity: item,
        trackType: 1,
      })
      goTo({
        url: item.link,
        extParams: {
          // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
          noCompileDchn: __mpx_mode__ === 'web' && !is('miniprogram'),
        },
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.banner-container
  margin 40rpx auto 0
  width: 710rpx;
  height 200rpx
  overflow hidden
  transform rotate(0deg)
  .swiper-container
    width 100%
    height 100%
    overflow hidden
    position relative
    border-radius 28rpx
    transform rotate(0deg)
    .image
      height 200rpx
      width 710rpx
</style>
<style lang="stylus">
.mpx-swiper
  overflow hidden
  position relative
.mpx-swiper-content
  width 100%
  height 100%
  display flex
  .mpx-swiper-item
    width 100%
    height 100%
    flex 1 0 auto
.mpx-swiper-dots
  position absolute
  right 50%
  bottom 25rpx
  // NOTE 为什么要使用translateZ
  // swiper-content拥有一个translateZ，这导致其会覆盖在指示器上方，导致指示器被隐藏
  transform translateX(50%) translateZ(11px)
  display flex
  .mpx-swiper-dots-item
    display block
    margin 4rpx
    width 8rpx
    height 8rpx
    border-radius 50%
</style>

<script type="application/json">
{
  "component": true
}
</script>
